import Modal from "react-modal";
import {useEffect, useState} from "react";
import * as d3 from "d3";
import mcOverlayCs from "../mc/1.0.0/mc-overlay-cs2d";

const crossSectionPromptStylesPc = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0px',
        border: '0px',
        borderRadius: '0px',
    },
    overlay: {
        backgroundColor: 'rgba(44, 47, 64, 0.8)',
    }
};

const crossSectionOverlayStylesPc = {
    content: {
        top: '15%',
        left: '10%',
        right: '10%',
        bottom: '15%',
        // marginRight: '-50%',
        // transform: 'translate(-50%, -50%)',
        padding: '0px',
        border: '0px',
        borderRadius: '0px',
    },
    overlay: {
        backgroundColor: 'rgba(44, 47, 64, 0.8)',
    }
};

const crossSectionPromptStylesMobile = {
    content: {
        top: '40%',
        // left: '50%',
        // right: 'auto',
        bottom: 'auto',
        // marginRight: '-50%',
        // transform: 'translate(-50%, -50%)',
        padding: '0px',
        border: '0px',
        borderRadius: '0px',
    },
    overlay: {
        backgroundColor: 'rgba(44, 47, 64, 0.8)',
    }
};

const crossSectionOverlayStylesMobile = {
    content: {
        top: '15%',
        left: '10%',
        right: '10%',
        bottom: '30%',
        // marginRight: '-50%',
        // transform: 'translate(-50%, -50%)',
        padding: '0px',
        border: '0px',
        borderRadius: '0px',
    },
    overlay: {
        backgroundColor: 'rgba(44, 47, 64, 0.8)',
    }
};

const CrossSectionModal = ({ isMobile, earthController, mouseMode, climateData, showPopupCsOverlay, setShowPopupCsOverlay, setClearMouseModeAction }) => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    useEffect(() => {
        setIsModalOpen(mouseMode === 'crossSection' &&  climateData ? true : false);
    }, [climateData])

    const handleClickCloseButton = () => {
        setIsModalOpen(false);
        setClearMouseModeAction(true);
        earthController.clearLocationDetailsCrossSection(true);
        setShowPopupCsOverlay(false);
    }

    const handleClickCrossSectionView = () => {
        setIsModalOpen(false);
        // setClearMouseModeAction(true);
        earthController.configuration.save({ showCrossSection: true });
        earthController.renderCrossSectionOverlay(climateData);
        if (earthController.configuration.get("projection") !== 'orthographic')
            setShowPopupCsOverlay(true);
    }

    return (
        <>
            <Modal isOpen={isModalOpen} style={ isMobile ? crossSectionPromptStylesMobile : crossSectionPromptStylesPc } appElement={document.getElementById('root')}>
                <div className="lpop lpop01">
                    <div className="lpop_con lpopc01">
                        <h2>선택위치 정보</h2>
                        <div className="w1">
                            <p className="e1">{isModalOpen && climateData ? `${Math.abs(Number(climateData.coords[0][1]).toFixed(2))}${Number(climateData.coords[0][1]) > 0 ? 'N' : 'S'},
                                ${Math.abs(Number(climateData.coords[0][0]).toFixed(2))}${Number(climateData.coords[0][0]) > 0 ? 'E' : 'W'}` : ''}</p>
                            <p className="e2">{isModalOpen && climateData ? `${Math.abs(Number(climateData.coords[256][1]).toFixed(2))}${Number(climateData.coords[256][1]) > 0 ? 'N' : 'S'},
                                ${Math.abs(Number(climateData.coords[256][0]).toFixed(2))}${Number(climateData.coords[256][0]) > 0 ? 'E' : 'W'}` : ''}</p>
                        </div>
                    </div>
                    <div className="lp_btns01">
                        <a href="javascript:;" className="lpbtn01" onClick={handleClickCloseButton}>
                            닫기
                        </a>
                        <a href="javascript:;" className="lpbtn02" onClick={handleClickCrossSectionView}>
                            연직단면보기
                        </a>
                    </div>
                </div>
            </Modal>
            <Modal isOpen={showPopupCsOverlay} onAfterOpen={
                () => {
                    let canvas = d3.select("#crossSection2d");
                    let width = canvas.node().parentElement.clientWidth, height = canvas.node().parentElement.clientHeight;

                    canvas.width = width * 1;
                    canvas.height = height * 1;
                    const crossSectionOverlay = mcOverlayCs(canvas, earthController.configuration);
                    earthController.configuration.save({ showCrossSection: true });
                    earthController.renderCrossSectionOverlay(climateData, crossSectionOverlay);
                }
            } style={ isMobile ? crossSectionOverlayStylesMobile : crossSectionOverlayStylesPc} appElement={document.getElementById('root')}>
                <div style={{width: '100%', height: '100%'}} onClick={() => { setShowPopupCsOverlay(false);earthController.clearLocationDetailsCrossSection(true); }}>
                    <canvas id="crossSection2d"></canvas>
                </div>
            </Modal>
        </>
    );
}

export default CrossSectionModal;